/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Heading_HighlightInputs */

const en_home_hero_heading_highlight = /** @type {(inputs: Home_Hero_Heading_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now unlock everything that comes with it.`)
};

const fr_home_hero_heading_highlight = /** @type {(inputs: Home_Hero_Heading_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez maintenant tout ce qui en fait partie.`)
};

/**
* | output |
* | --- |
* | "Now unlock everything that comes with it." |
*
* @param {Home_Hero_Heading_HighlightInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_heading_highlight = /** @type {((inputs?: Home_Hero_Heading_HighlightInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Heading_HighlightInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_heading_highlight(inputs)
	return fr_home_hero_heading_highlight(inputs)
});